import { Maybe } from '@/tina/__generated__/types';
import * as stylex from '@stylexjs/stylex';
import { tinaField } from 'tinacms/dist/react';
import { a11y } from '../styles/a11y';
import '../styles/tokens.stylex';
import { spacing } from '../styles/tokens.stylex';
import { typography } from '../styles/typography';
import { FiveStars } from './svg/images/fiveStars';
import { ReviewsIoLogo } from './svg/images/reviewsIo';
import { NextLinkWithEventPayload } from './NextLinkWithEventPayload';
export interface ReviewStatementProps {
  data: {
    reviewStatement?: Maybe<string>;
    [key: string]: unknown;
  };
}
export function ReviewStatement({
  data
}: ReviewStatementProps) {
  return <div className="x16pmaob x1cy8zhl x78zum5 x1q0g3np x8hhl5t x1qughib">
      <p {...stylex.props(typography.heading3, sx.reviewsStatement)} data-tina-field={tinaField(data, 'reviewStatement')}>
        {data.reviewStatement}
      </p>
      <NextLinkWithEventPayload href="https://www.reviews.io/company-reviews/store/https-www.aomail.com.au" target="_blank" rel="noopener noreferrer" className="x10f5beq x1cy8zhl x78zum5 xdt5ytf x1clqncf x2ybbfa" clickEventPayload={{
      event: 'reviews_IO_click',
      location: 'hero'
    }}>
        <ReviewsIoLogo />
        <FiveStars />
        <span {...stylex.props(a11y.visuallyHidden)}>
          Read our Reviews on Reviews.io
        </span>
      </NextLinkWithEventPayload>
    </div>;
}
const sx = {
  reviewsStatement: {
    kCS8Yb: "x4y2jaj",
    $$css: true
  }
};